import { Button, DrawerBodyWrapper, DrawerFooterWrapper, Input, Select, TOAST_TYPE } from '@base'
import { ChargeListWrapper } from '@pages/Admin/Orders/ManageOrder/EditInvoice'
import { strings } from '@constants'
import { useEffect, useState } from 'react'
import { ListItemWrapper, ListWrapper } from '../PaymentTerms'
import { Delete } from '@material-ui/icons'
import { useDispatch } from 'react-redux'
import { showLoader, showToast } from '@data/state/action'
import { getProductByCategory } from '@data'
import { displayAmount } from '@utils'

const deriveFormState = (data) => {
	let _state = {
		product_id: {
			id: 'product-id',
			label: 'Product',
			placeholder: 'Choose Product',
			value: '',
			dirty: false,
			required: false,
		},
		hsn_code: {
			id: 'hsn-code',
			label: 'HSN Code',
			placeholder: 'Enter HSN Code',
			value: '',
			dirty: false,
			required: false,
		},
		rate_per_mt: {
			id: 'rate-per-mt',
			label: 'Rate per MT',
			placehodler: 'Enter Rate per MT',
			value: '',
			dirty: false,
			required: false,
		},
		rate_lumpsum: {
			id: 'rate-lumpsum',
			label: 'Lumpsum Amount',
			placeholder: 'Enter Lumpsum Amount',
			value: '',
			dirty: false,
			required: false,
		},
	}
	if (data) {
		_state.product_id.value = data?.product_id
		_state.hsn_code = data?.hsn_code
		_state.rate_per_mt = data?.rate_per_mt
		_state.rate_lumpsum = data?.rate_lumpsum
	}
	return _state
}

const AddOtherCharges = ({ update, edit = false, submitCallback, editCallback, data = null }) => {
	const dispatch = useDispatch()
	const [otherChargesList, setOtherChargesList] = useState(data ?? [])
	const [OtherChargesTypeList, setOtherChargesTypeList] = useState([])
	const [formState, setFormState] = useState(deriveFormState())

	useEffect(() => {
		dispatch(showLoader(true))
		getProductByCategory('other_services')
			.then((response) => {
				setOtherChargesTypeList(response)
			})
			.catch((error) => {})
			.finally(() => {
				dispatch(showLoader(false))
			})
	}, [])

	const updateState = (key) => (value) => {
		setFormState((_s) => ({
			..._s,
			[key]: {
				..._s[key],
				value,
			},
		}))
	}

	const selectOtherChargesType = (value) => {
		if (otherChargesList?.find((item) => item?.product_id === value?.product_id)) {
			dispatch(showToast(true, strings('msg_other_charges_already_exist'), { type: TOAST_TYPE.ERROR }))
			return
		}
		updateState('product_id')(value?.product_id)
		updateState('hsn_code')(value?.hsn_code)
	}

	const addChargeHandler = () => {
		let _temp = OtherChargesTypeList.find((item) => item.product_id === formState?.product_id?.value)
		setOtherChargesList([
			...otherChargesList,
			{
				product_id: _temp?.product_id,
				rate_per_mt: formState?.rate_per_mt?.value !== '' ? formState?.rate_per_mt?.value : null,
				hsn_code: _temp.hsn_code,
				product_name: _temp?.product_name,
				rate_lumpsum: formState?.rate_lumpsum?.value !== '' ? formState?.rate_lumpsum?.value : null,
				category_id: 'other_services',
				category_name: 'Other Services',
			},
		])
		clearState()
	}

	const deleteOtherCharge = (_val, index) => {
		setOtherChargesList(otherChargesList.filter((item, idx) => idx !== index))
	}

	const clearState = () => {
		setFormState(deriveFormState())
	}

	const submitHandler = () => {
		submitCallback(otherChargesList)
	}

	const updateHandler = () => {
		editCallback(otherChargesList)
	}

	return (
		<>
			<DrawerBodyWrapper>
				<ChargeListWrapper>
					<Select
						label={strings(['other', 'charges', 'type'])}
						placeholder={strings(['select', 'other', 'charges', 'type'])}
						primaryKey='product_id'
						displayKey='product_name'
						value={OtherChargesTypeList.find((item) => item.product_id === formState?.product_id?.value) ?? {}}
						data={OtherChargesTypeList}
						onChange={(value) => {
							selectOtherChargesType(value)
						}}
					/>
					<Input
						id={formState?.hsn_code?.id}
						label={formState?.hsn_code?.label}
						placeholder={formState?.hsn_code?.placeholder}
						value={formState?.hsn_code?.value ?? ''}
						onChange={(value) => {
							updateState('hsn_code')(value)
						}}
					/>
				</ChargeListWrapper>
				<ChargeListWrapper>
					<Input
						type='number'
						label={formState?.rate_per_mt?.label}
						placeholder={formState?.rate_per_mt?.placehodler}
						value={formState?.rate_per_mt?.value}
						onChange={(value) => {
							updateState('rate_per_mt')(value)
						}}
						disabled={formState?.rate_lumpsum?.value}
					/>
					<Input
						type='number'
						label={formState?.rate_lumpsum?.label}
						placeholder={formState?.rate_lumpsum?.placeholder}
						value={formState?.rate_lumpsum?.value ?? ''}
						onChange={(value) => {
							updateState('rate_lumpsum')(value)
						}}
						disabled={formState?.rate_per_mt?.value}
					/>
				</ChargeListWrapper>
				<Button small xs margin={`0 0 0 auto`} onClick={addChargeHandler} disabled={!formState?.product_id?.value}>
					{strings('add')}
				</Button>

				<ListWrapper>
					{otherChargesList?.map((_item, index) => {
						let rate =
							_item?.rate_per_mt !== null
								? `${displayAmount(_item?.rate_per_mt)} per MT`
								: `${displayAmount(_item?.rate_lumpsum)} lumpsum`

						return (
							<ListItemWrapper oneButton>
								<div>{`${_item?.product_name} (${rate})`}</div>

								<Button xs variant='destructive' type='secondary' margin={'0 0 0 0'} onClick={() => deleteOtherCharge(_item, index)}>
									<Delete />
								</Button>
							</ListItemWrapper>
						)
					})}
				</ListWrapper>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				{!edit ? (
					<Button small onClick={submitHandler}>
						{strings('submit')}
					</Button>
				) : (
					<Button small onClick={updateHandler}>
						{strings('update')}
					</Button>
				)}
			</DrawerFooterWrapper>
		</>
	)
}

export default AddOtherCharges
